export const STANDARD_COLUMN_TYPE_META = {
    STRING: { icon: "fa-font", label: "Text" },
    NUMBER: { icon: "fa-hashtag", label: "Number" },
    DECIMAL: { icon: "fa-calculator", label: "Decimal" },
    BOOLEAN: { icon: "fa-toggle-on", label: "Yes / No" },
    DATE: { icon: "fa-calendar", label: "Date" },
    DATETIME: { icon: "fa-calendar-plus-o", label: "Date & Time" },
    TIME: { icon: "fa-clock-o", label: "Time" },
    LIST: { icon: "fa-list-ul", label: "List" },
    ENUM: { icon: "fa-tag", label: "Dropdown" },
    URL: { icon: "fa-link", label: "Link" },
    MIRROR: { icon: "fa-clone", label: "Mirror" },
}

export const FK_MODEL_META = {
    car: { icon: "fa-car", label: "Car" },
    driver: { icon: "fa-user", label: "Driver" },
    incident: { icon: "fa-exclamation-triangle", label: "Incident" },
    carissues: { icon: "fa-wrench", label: "Car Issue" },
    liabilityclaim: { icon: "fa-balance-scale", label: "Liability Claim" },
    subrogationclaim: { icon: "fa-file-text-o", label: "Subrogation Claim" },
}

export const formatContentTypeLabel = (modelName = "") => {
    const normalizedModel = String(modelName || "").toLowerCase()
    return FK_MODEL_META[normalizedModel]?.label
        || normalizedModel.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/^\w/, (char) => char.toUpperCase())
}

export const getCustomColumnIcon = (columnNode) => {
    if (!columnNode) return "fa-columns"
    if (columnNode.columnType === "FK_OBJECT") {
        return FK_MODEL_META[columnNode.contentType?.model]?.icon || "fa-cube"
    }
    return STANDARD_COLUMN_TYPE_META[columnNode.columnType]?.icon || "fa-columns"
}
